
<lg-navbar></lg-navbar>
<div class="my-4 d-flex justify-content-center">
  <router-outlet></router-outlet>
</div>
<footer>© Logalty Prueba por Interposición, S.L. &nbsp;&nbsp;&nbsp; <a href="{{'NAVBAR.PRIVACYLINK' | translate}}" target="_blank">{{'NAVBAR.PRIVACY' | translate}} </a><br><small>Valportillo Primera, 22. Planta 1. Ed. Caoba, 28108 Alcobendas, Madrid, España</small></footer>